import BuildingForm from './BuildingForm'
import BuildingListTable from './BuildingListTable'

export { BuildingListTable, BuildingForm }